import { Component, Input, input } from '@angular/core';
import {
  NumberInputComponent,
  TextInputComponent,
  CheckboxInputComponent,
} from '@navstation-portal/shared/ui/components';
import { FormsModule } from '@angular/forms';
import {
  StateField,
  StateFieldType,
} from '@navstation-portal/reporting/data-model/vessel-report';
import {
  FormStoreInitPayload,
  FormStoreEventPayload,
} from '@navstation-portal/reporting/data-access/vessel-report';
import {
  FormConfigItem,
  OffshoreFormStoreInitPayload,
} from '@navstation-portal/reporting/data-model/offshore-report';
import { AbstractStoreConnectedSectionComponent } from '@navstation-portal/reporting/data-access/offshore-report';

@Component({
  selector: 're-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  imports: [
    NumberInputComponent,
    TextInputComponent,
    CheckboxInputComponent,
    FormsModule,
  ],
})
export class DynamicFormComponent extends AbstractStoreConnectedSectionComponent {
  @Input({ required: true }) tabId!: string;
  sectionId = 'dynamicSection';

  @Input({ required: true }) override events!: {
    initialiseFormState: (payload: OffshoreFormStoreInitPayload) => void;
    updateFormStateTouched: (payload: FormStoreEventPayload) => void;
    updateFormStatePristine: (payload: FormStoreEventPayload) => void;
    updateFormStateStatus: (payload: FormStoreEventPayload) => void;
    updateFormStateValue: (payload: FormStoreEventPayload) => void;
  };

  parsers = {
    checkbox: (v: StateFieldType) => (v ? Boolean(v) : undefined),
    number: (v: StateFieldType) => (v ? Number(v) : undefined),
    text: (v: StateFieldType) => (v ? String(v) : undefined),
  } as const;

  formConfig = input<FormConfigItem[]>([]);
  storeSectionState = input<Record<string, StateField<StateFieldType>>>({});
}
